module.exports = __webpack_public_path__ + "static/spiralIcon-877d762b00ac94fd78b1b92124767ce0.png";